export interface NewsArticle {
  id: number;
  title: string;
  summary: string;
  content: string;
  publishTime: string;
  cover: string;
  category: string;
  author: string;
  keywords: string[];
}

export const newsArticles: NewsArticle[] = [
  {
    id: 3001,
    title: '2024年暑期档前瞻：这十部影片有望引爆票房',
    summary: '随着暑期档临近，多部备受期待的影片陆续定档。从科幻巨制到温情剧情，这个夏天的大银幕格外热闹，我们盘点了最值得关注的十部作品。',
    content:
      '每年暑期档都是全年票房最重要的战场之一。今年，多部类型各异的重磅影片集中在六至八月上映，既有工业水准拉满的科幻与灾难大片，也有口碑导向的现实题材与温情剧情。\n\n从目前公布的信息来看，续集与原创各占半壁江山。系列作品凭借既有观众基础占据先机，而原创影片则依靠题材的新鲜感与口碑发酵争取长线表现。业内普遍认为，今年暑期档整体竞争会非常激烈，头部影片的排片争夺将直接决定最终格局。\n\n对观众而言，这无疑是个好消息——选择变多了。无论你偏爱紧张刺激的动作场面，还是愿意为一段细腻的情感故事买单，这个夏天都很难找不到想看的那一部。我们也建议提前关注影片的预告与点映口碑，合理规划观影档期。',
    publishTime: '2024-05-28',
    cover: 'https://readdy.ai/api/search-image?query=Cinema%20hall%20with%20rows%20of%20seats%20and%20a%20glowing%20screen%2C%20editorial%20film%20industry%20photography%2C%20deep%20navy%20darkness%20with%20warm%20orange%20projector%20glow%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=520&seq=news-cover-01&orientation=landscape',
    category: '行业观察',
    author: '影评编辑部',
    keywords: ['暑期档', '票房', '定档', '电影前瞻'],
  },
  {
    id: 3002,
    title: '《星际远征》口碑票房双丰收，续作正式提上日程',
    summary: '上映三周，《星际远征》累计票房突破二十亿，豆瓣评分稳定在9.0以上。制片方近日确认，续集已进入前期筹备阶段。',
    content:
      '作为今年最具话题度的科幻作品之一，《星际远征》自上映以来便保持着极高的讨论热度。影片以扎实的世界观设定与细腻的人物情感打动了大量观众，不少影迷表示「终于看到一部既有想象力又不忘讲人的国产科幻」。\n\n票房方面，影片在上映第三周仍保持着稳定的上座率，长线表现远超业内预期。制片方在近期的发布会上回应了观众的期待，确认续集项目已经启动，将延续第一部的核心团队，同时在视效与叙事上寻求更大突破。\n\n对于喜爱这一系列的观众来说，这无疑是值得等待的消息。也有影评人提醒，续集面临的最大挑战不是特效，而是如何在已有世界观之上讲出一个同样有分量的故事。',
    publishTime: '2024-07-30',
    cover: 'https://readdy.ai/api/search-image?query=Space%20nebula%20with%20a%20spiral%20wormhole%20in%20deep%20navy%20and%20warm%20orange%20glow%2C%20editorial%20sci-fi%20article%20image%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=520&seq=news-cover-02&orientation=landscape',
    category: '影片动态',
    author: '记者 林小舟',
    keywords: ['星际远征', '续集', '票房', '科幻'],
  },
  {
    id: 3003,
    title: '深度解析：国产科幻电影的崛起之路',
    summary: '从被质疑到被期待，国产科幻电影用十年时间完成了一次蜕变。本文从工业能力、叙事方式与观众审美三个维度，回望这段并不轻松的路。',
    content:
      '很长一段时间里，「国产科幻」四个字在观众心中意味着廉价特效与尴尬台词。但转折发生得比很多人想象中更快。随着一批创作者开始认真对待类型片规律，国产科幻逐渐找到了属于自己的表达方式。\n\n工业层面，虚拟拍摄、实时渲染与本土视效团队的成长，让影片的完成度有了质的提升。叙事层面，越来越多的作品不再满足于炫技，而是尝试把科幻设定与本土情感结合，讲出更具共鸣的故事。观众审美的成熟同样关键，当市场愿意为好内容买单，创作者才有底气去冒险。\n\n当然，挑战依然存在。如何在商业性与思想性之间取得平衡，如何避免题材的同质化，仍是行业需要持续回答的问题。但至少可以确定的是，那条路已经有人走过来了。',
    publishTime: '2024-06-15',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20film%20studio%20with%20warm%20orange%20lighting%20and%20deep%20navy%20shadows%2C%20editorial%20technology%20photography%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=520&seq=news-cover-03&orientation=landscape',
    category: '深度解析',
    author: '特约撰稿人 沈知',
    keywords: ['国产科幻', '电影工业', '类型片', '深度解析'],
  },
  {
    id: 3004,
    title: '本周新剧推荐：五部高口碑电视剧不容错过',
    summary: '从古装悬疑到都市情感，本周五部新剧口碑表现亮眼。我们按类型整理了看点与适合人群，帮你快速锁定想追的那一部。',
    content:
      '本周上线的五部新剧覆盖了古装、都市、刑侦与科幻等多个类型，整体口碑表现相当扎实。古装悬疑剧《长安夜行》凭借精良的制作与紧凑的节奏率先出圈，多条支线交织的叙事方式让观众直呼「一集入坑」。\n\n都市情感剧《都市浮生记》则把镜头对准了普通打工人的日常，没有刻意煽情，却处处是生活的影子。科幻悬疑的《时空迷航》胜在设定新颖，喜欢烧脑的观众可以重点关注。\n\n如果你是刑侦类型的忠实观众，《刑警日记》值得一看；偏好轻松治愈的话，深夜料理题材的《甜心料理屋》会是不错的选择。五部作品各有千秋，按自己的口味挑一部开追就好。',
    publishTime: '2024-08-06',
    cover: 'https://readdy.ai/api/search-image?query=Stack%20of%20TV%20series%20posters%20on%20a%20dark%20wall%20with%20warm%20orange%20rim%20light%2C%20editorial%20image%2C%20deep%20navy%20tones%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=520&seq=news-cover-04&orientation=landscape',
    category: '剧集推荐',
    author: '追剧小组',
    keywords: ['新剧推荐', '电视剧', '口碑', '追剧'],
  },
  {
    id: 3005,
    title: '专访导演沈砚秋：如何拍出一部好电影',
    summary: '从《山河故人梦》到《旧日回响》，导演沈砚秋始终关注时代洪流中的普通人。这次我们和他聊了聊创作、选角与那些没被写进剧本的细节。',
    content:
      '在采访开始前，沈砚秋导演先递来一杯茶，说自己习惯用很慢的节奏进入一个话题。谈及创作，他反复提到一个词：真实。「观众不傻，你哪一段是为了攒情绪，哪一段是真的想说话，他们看得出来。」\n\n关于选角，他坦言自己更看重演员与角色的「气质契合」，而不是单纯的名气或技巧。「有些演员一站到镜头前，你就知道他是那个人，这比什么都重要。」\n\n当被问到如何看待票房与口碑的平衡，他笑了笑：「我当然希望两者都有。但如果一定要选，我还是会选一部十年后还有人愿意重看的电影。」这句话，大概也是他所有作品的注脚。',
    publishTime: '2024-04-22',
    cover: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20and%20clapperboard%20on%20a%20quiet%20set%20with%20warm%20orange%20light%2C%20editorial%20interview%20photography%2C%20deep%20navy%20shadows%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=520&seq=news-cover-05&orientation=landscape',
    category: '人物专访',
    author: '记者 林小舟',
    keywords: ['导演专访', '沈砚秋', '电影创作', '幕后'],
  },
  {
    id: 3006,
    title: '全球票房榜出炉，华语影片表现亮眼',
    summary: '最新一期全球周末票房榜公布，多部华语影片跻身前列。分析认为，本土市场的强劲表现是重要支撑，海外发行也在稳步推进。',
    content:
      '最新公布的全球周末票房榜显示，多部华语影片进入前十，其中两部更是位列前五，成绩相当亮眼。业内人士分析，这一方面得益于本土市场持续释放的观影需求，另一方面也说明华语影片的海外发行渠道正在逐步拓宽。\n\n值得注意的是，上榜影片的类型分布比往年更加均衡，既有商业大片，也有中小成本的现实题材作品。这说明观众的观影选择越来越多元化，市场不再只由单一类型主导。\n\n随着更多影片启动海外同步发行，华语电影在全球舞台上的能见度有望进一步提高。当然，如何讲出既属于本土又能被世界理解的故事，依然是长期课题。',
    publishTime: '2024-03-11',
    cover: 'https://readdy.ai/api/search-image?query=Global%20box%20office%20chart%20concept%20with%20a%20glowing%20world%20map%20in%20deep%20navy%20and%20warm%20orange%2C%20editorial%20data%20visual%20image%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=520&seq=news-cover-06&orientation=landscape',
    category: '行业观察',
    author: '数据组',
    keywords: ['票房榜', '华语影片', '海外发行', '市场'],
  },
  {
    id: 3007,
    title: '经典重映热潮来袭，老电影为何历久弥新',
    summary: '近两年，越来越多经典影片以修复版重回大银幕，并取得超出预期的票房。这股重映热潮背后，是情怀，也是观众对好故事的持久信任。',
    content:
      '如果说新片代表电影市场的活力，那么经典重映则是它沉淀下来的底气。近两年，多部修复版经典影片陆续回到大银幕，不少场次甚至一票难求。\n\n观众走进影院重温旧片，当然有情怀的成分，但更重要的是作品本身经得起时间的检验。那些关于选择、成长与告别的主题，不会因为年代久远而褪色，反而在岁月里愈发清晰。\n\n对创作者来说，这或许是一种提醒：真正的好故事，不会被时间打败。对观众而言，能在更好的银幕条件下重看一部陪伴过自己的老电影，本身也是一种难得的浪漫。',
    publishTime: '2024-02-18',
    cover: 'https://readdy.ai/api/search-image?query=Old%20film%20reels%20and%20vintage%20projector%20in%20warm%20orange%20light%20with%20deep%20navy%20shadows%2C%20nostalgic%20editorial%20photography%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=520&seq=news-cover-07&orientation=landscape',
    category: '文化评论',
    author: '特约撰稿人 沈知',
    keywords: ['经典重映', '修复版', '情怀', '老电影'],
  },
  {
    id: 3008,
    title: '影视工业化背后的技术革新：虚拟拍摄如何改变剧组',
    summary: '虚拟拍摄、实时渲染与云端协作，正在重塑影视制作的流程。技术不仅降低了成本，也让创作者拥有了更大的想象空间。',
    content:
      '过去需要辗转多地取景、耗费数周搭建的场景，如今在一块巨大的 LED 环幕前就能完成。虚拟拍摄技术的成熟，让「所见即所得」成为现实，演员在拍摄时便能看到最终的背景环境。\n\n这项改变带来的不仅是效率的提升。更短的外景周期、更可控的光线条件、更灵活的档期安排，都在切实降低制作的综合成本。对于预算有限的中小成本剧组而言，这意味着更多原本做不了的题材变得可行。\n\n技术当然不是万能的，它替代不了好剧本与好表演。但当工具的门槛降低，创作者就能把更多精力放在真正重要的地方——讲好一个故事。这大概才是技术革新最值得被看见的意义。',
    publishTime: '2024-01-29',
    cover: 'https://readdy.ai/api/search-image?query=LED%20virtual%20production%20stage%20with%20glowing%20screen%20in%20deep%20navy%20and%20warm%20orange%20light%2C%20editorial%20technology%20photography%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=520&seq=news-cover-08&orientation=landscape',
    category: '技术前沿',
    author: '记者 林小舟',
    keywords: ['虚拟拍摄', '影视工业化', '技术革新', '制作流程'],
  },
];